import { useState } from 'react';
import { getCard, type DrawnCard } from '@tarot/shared';
import { CardLightbox } from './CardLightbox';

/**
 * 타로 카드 1장 렌더 (RWS 이미지 — doc/card-assets.md).
 * 기본적으로 클릭 시 라이트박스로 확대 (zoomable=false로 끌 수 있음).
 * 이미지 경로는 shared의 imageKey가 단일 출처.
 */
export function TarotCard({
  drawn,
  className = '',
  zoomable = true,
}: {
  drawn: DrawnCard;
  className?: string;
  zoomable?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const card = getCard(drawn.cardId);
  const dir = drawn.reversed ? '역방향' : '정방향';

  const img = (
    <img
      src={`/${card.imageKey}`}
      alt={`${card.nameKo} ${dir}`}
      loading="lazy"
      draggable={false}
      className={`aspect-[3/5] w-full select-none rounded-lg border border-gold/30 object-cover shadow-lg shadow-black/40 ${
        drawn.reversed ? 'rotate-180' : ''
      } ${className}`}
    />
  );

  if (!zoomable) return img;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={`${card.nameKo} 크게 보기`}
        className="w-full cursor-zoom-in transition hover:brightness-110 active:scale-[0.98]"
      >
        {img}
      </button>
      <CardLightbox drawn={drawn} open={open} onClose={() => setOpen(false)} />
    </>
  );
}
